<ion-content class="ion-text-center ion-padding">
  <div class="background"></div>

  <div class="content">
    <!-- Logo -->
    <svg class="logo" xmlns="http://www.w3.org/2000/svg" width="212.311" height="237.583" viewBox="0 0 212.311 237.583">
      <defs>
        <style>
          .a {
            fill: #fff;
          }
        </style>
      </defs>
      <g transform="translate(-1532.687 -701.704)">
        <path
          class="a"
          d="M1562.437,910.057h-12.595v28.626h7.32v-7.32h5.275C1576.137,931.363,1576.137,910.1,1562.437,910.057Zm-.041,14.722h-5.234V916.6c1.677,0,3.517-.04,5.234,0C1566.649,916.641,1566.4,924.779,1562.4,924.779Z"
        />
        <path class="a" d="M1583.332,927.151h9.733v-6.5h-9.733V916.6h10.592v-6.543h-17.87v28.626h18.238v-6.5h-10.96Z" />
        <path class="a" d="M1595.6,916.6h7.034v22.083h7.238V916.6h6.993v-6.543H1595.6Z" />
        <path
          class="a"
          d="M1633.1,922.407l-11.205-12.431h-2.7v28.707h7.484V925.924l6.052,6.379h.818l6.093-6.379v12.759h7.483V909.976h-2.617Z"
        />
        <path
          class="a"
          d="M1650.476,924.411c0,19.834,29.361,19.834,29.361,0C1679.837,904.619,1650.476,904.619,1650.476,924.411Zm7.524,0c0-10.3,14.354-10.3,14.354,0C1672.354,934.8,1658,934.8,1658,924.411Z"
        />
        <path
          class="a"
          d="M1695.7,910.057h-12.555v28.626h7.32v-8.424h3.8l4.907,8.424h8.179V937.62l-5.6-9.079C1708.993,923.634,1706.949,910.1,1695.7,910.057Zm0,13.618h-5.235V916.6c1.718,0,3.517-.04,5.235,0C1699.874,916.641,1699.67,923.675,1695.7,923.675Z"
        />
        <path class="a" d="M1716.884,932.181v-5.03h9.733v-6.5h-9.733V916.6h10.592v-6.543H1709.6v28.626h18.239v-6.5Z" />
        <path
          class="a"
          d="M1726.481,719.217a61.509,61.509,0,0,0-87.642,1.7,61.5,61.5,0,0,0-106.152,42.289c0,16.963,5.618,33.711,16.695,49.778,8.685,12.6,20.741,24.808,35.831,36.287a258.966,258.966,0,0,0,51.618,30.349,5.255,5.255,0,0,0,4,.011,255.11,255.11,0,0,0,51.634-30.115c15.1-11.436,27.154-23.638,35.842-36.268,11.075-16.1,16.691-32.937,16.691-50.041A61.109,61.109,0,0,0,1726.481,719.217Zm-92.918,100.177c1.771,2.61,4.219,7.369,3.32,12.817-1.135,6.873-7.145,13.268-17.864,19.017a23.934,23.934,0,0,1-3.359-8.521c.148-.436,7.6-9.591,10.413-13.347C1628.239,826.464,1630.9,822.916,1633.563,819.394Zm23.754,13.477c.63,1.94,5.082,18.714-24.258,30.587a27.316,27.316,0,0,1-8.672-5.528c12.357-6.935,19.372-15.153,20.86-24.454,1.633-10.207-4.039-18.267-6.345-21.055a92,92,0,0,1,6.945-8.344c2.82-2.477,5.758-3.61,8.739-3.369a11.844,11.844,0,0,1,7.951,4.33,39.674,39.674,0,0,1,3.672,5.884,26.514,26.514,0,0,0-6.156,3.064C1653.8,818.93,1655.3,826.675,1657.317,832.871Zm20.369-41.18a5.357,5.357,0,0,0,2.315,4.553c.115.08,11.457,8.222,4.2,30.4-5.108,15.616-14.543,23.815-19.9,27.4-1.6.837-3.159,1.638-4.671,2.4,10.337-12.279,6.98-24.459,6.353-26.387-2.363-7.275-.956-8.386-.3-8.909a46.677,46.677,0,0,1,8.271-3.271,4.557,4.557,0,0,0,2.781-6.234c-.383-.844-3.846-8.359-7.167-12.394a20.833,20.833,0,0,0-14.252-7.622,18.765,18.765,0,0,0-5.822.441l17.427-50.937.012-.035c.541-.525,1.064-.632,1.534-.143.241.251,5.529,8.25,8.538,9.856,1.644.876,5.562-.019,10.268,2.2,6.548,3.087,6.334,7.832,9.572,8.848,2.31.725,14.786-.227,16.013-.355,1.342-.14.276.412,1.8,2.56.406.574,1.214.67,1.263,1.145.652,6.345-8.359,15.453-14.171,18.752-8.615,4.891-18.6,2.231-18.718,2.209a4.618,4.618,0,0,0-5.347,5.524Zm14.171,44.941a70.641,70.641,0,0,0,2.555-6.651c5.5-16.812,2.352-28.064-1.552-34.759,5.483-.781,12.3-2.668,17.516-6.428,12.811-9.228,13.254-17.829,13.128-25.276-.012-.672-.023-1.331-.023-1.976a4.578,4.578,0,0,0-.337-1.723c1.263-3.3-.111-4.647-3.98-4.647-1.521-.217-16.2,1.2-19.172.752-2.243-2.882-9.045-10.477-14.158-11.9a62.759,62.759,0,0,0-6.251-9.725,1.793,1.793,0,0,0-2.133-.494,10.855,10.855,0,0,0-3.642,3.507c-2.11-2.658-4.4-5.275-5.675-5.328-1.6-.637-3.544-.115-5.518,1.291a13.03,13.03,0,0,0-4.666,6.4s-15.357,43.087-21.018,60.658c-3.951,4.643-10.426,13.231-18.154,23.558-2.13,2.847-4.036,5.393-5.571,7.417-1-8.723-.293-19.1,3.5-31.156a83.96,83.96,0,0,1,6.165-11.514c7.721-12.744,15.015-24.782-3.766-49.989a4.558,4.558,0,0,0-6.346-.953,4.724,4.724,0,0,0-.486.411c-.645.591-5.627,5.053-9.621,8.626a31.626,31.626,0,0,0-12.844,2.758,32.167,32.167,0,0,0-10.465,6.841l-10.828.627a4.826,4.826,0,0,0-2.836,1.21s-.1.088-.263.26c-2.674,2.786-3.42,12.707-.335,20.848,2.942,7.762,10.3,17.328,28.639,18.822a4.556,4.556,0,1,0,.74-9.082c-9.18-.748-15.633-3.974-19.179-9.589a22.439,22.439,0,0,1-3.015-13.559l9.485-.549a4.447,4.447,0,0,0,3.389-1.825c.024-.032,2.51-3.218,8.192-5.6,5.854-2.455,9.444-2.06,9.906-1.994a4.207,4.207,0,0,0,4.016-1.057l5.624-5.033,1.814-1.626c11.55,17.308,7.013,24.793.385,35.733a91.525,91.525,0,0,0-6.876,12.96c-.047.114-.089.229-.126.346-7.672,24.221-3.994,42.479,1.121,54.256-7.256-4.057-14.846-8.439-17.637-10.562-22.074-16.792-48.387-43.906-48.387-77.72a51.015,51.015,0,0,1,89.173-33.857c.824.929,1.622,1.9,2.371,2.875a5.187,5.187,0,0,0,4.125,2.008h0A5.24,5.24,0,0,0,1643,732.18a51.013,51.013,0,0,1,91.509,31.026C1734.512,794.451,1712.473,819.77,1691.857,836.632Z"
        />
      </g>
    </svg>
    <!-- Botões de Login/Cadastro -->
    <div class="buttons">
      <ion-button
        shape="round"
        color="primary"
        expand="block"
        class="ion-margin-top ion-margin-bottom buttons__login buttons__btn"
        [routerLink]="signUpUrl"
        >Não tenho cadastro</ion-button
      >
      <ion-button
        shape="round"
        color="secondary"
        expand="block"
        class="ion-margin-top ion-margin-bottom buttons__signup buttons__btn"
        [routerLink]="loginUrl"
        >Já sou cadastrado</ion-button
      >
    </div>
    <!-- Botão Sou Parceiro -->
    <!-- Por enquanto, o login de parceiro está sendo no mesmo local de tutor -->
    <div class="partner-links">
      <ion-button
        fill="clear"
        class="ion-margin-top ion-margin-bottom ion-text-uppercase partner-link"
        color="light"
        [routerLink]="partnerLoginUrl"
        >Sou parceiro</ion-button
      >
      <ion-button
        fill="clear"
        class="ion-margin-top ion-margin-bottom ion-text-uppercase partner-link"
        color="light"
        (click)="onNewPartnerClick()"
        >Quero ser parceiro</ion-button
      >
    </div>
  </div>
</ion-content>
